export type UniformTypeIdentifierBase =
  | "ca.mcgill.mni.bic.mnc"
  | "com.adobe.actionscript"
  | "com.adobe.cold-fusion-markup"
  | "com.adobe.edn"
  | "com.adobe.encapsulated-postscript"
  | "com.adobe.etd"
  | "com.adobe.fdf"
  | "com.adobe.flash.video"
  | "com.adobe.illustrator.ai-image"
  | "com.adobe.pdf"
  | "com.adobe.photoshop-image"
  | "com.adobe.photoshop-large-image"
  | "com.adobe.photoshop.brush"
  | "com.adobe.postscript"
  | "com.adobe.postscript-font"
  | "com.adobe.postscript-lwfn-font"
  | "com.adobe.postscript-pfa-font"
  | "com.adobe.postscript-pfb-font"
  | "com.adobe.raw-image"
  | "com.adobe.xfdf"
  | "com.agilebits.itemmetadata"
  | "com.agilebits.legacyagilekeychain"
  | "com.agilebits.opvault"
  | "com.agiletortoise.drafts.action"
  | "com.agiletortoise.drafts.actiongroup"
  | "com.agiletortoise.drafts.draftsexport"
  | "com.agiletortoise.drafts.languagegrammar"
  | "com.agiletortoise.drafts.theme"
  | "com.agiletortoise.drafts.workspace"
  | "com.allume.stuffit-archive"
  | "com.android.package-archive"
  | "com.apple.accounts-icon"
  | "com.apple.active-webpage"
  | "com.apple.addressbook.group"
  | "com.apple.addressbook.group-object"
  | "com.apple.addressbook.item-object"
  | "com.apple.addressbook.person"
  | "com.apple.addressbook.person-object"
  | "com.apple.afp-internet-location"
  | "com.apple.airdrop"
  | "com.apple.airport"
  | "com.apple.airport-express"
  | "com.apple.airport-extreme-tower"
  | "com.apple.airport-time-capsule-tower"
  | "com.apple.alert"
  | "com.apple.alert-caution"
  | "com.apple.alert-note"
  | "com.apple.alert-stop"
  | "com.apple.alias-file"
  | "com.apple.alias-record"
  | "com.apple.aperture.library"
  | "com.apple.apple-tv"
  | "com.apple.apple-tv-2"
  | "com.apple.apple-tv-3"
  | "com.apple.apple-tv-3a"
  | "com.apple.apple-tv-4"
  | "com.apple.apple-tv-4k"
  | "com.apple.apple-tv-4k-2nd"
  | "com.apple.applescript.alias-object"
  | "com.apple.applescript.alias-object.image"
  | "com.apple.applescript.alias-object.movie"
  | "com.apple.applescript.alias-object.pdf"
  | "com.apple.applescript.data-object"
  | "com.apple.applescript.object"
  | "com.apple.applescript.script"
  | "com.apple.applescript.script-bundle"
  | "com.apple.applescript.text"
  | "com.apple.applescript.text-object"
  | "com.apple.applescript.url-object"
  | "com.apple.applesingle-archive"
  | "com.apple.application"
  | "com.apple.application-and-system-extension"
  | "com.apple.application-bundle"
  | "com.apple.application-file"
  | "com.apple.application-placeholder"
  | "com.apple.applications-folder"
  | "com.apple.appstore.appdownload"
  | "com.apple.archive"
  | "com.apple.ariadne.artrace"
  | "com.apple.arobject"
  | "com.apple.ascii-property-list"
  | "com.apple.audio-unit-preset"
  | "com.apple.automator-action"
  | "com.apple.automator-conversion-action"
  | "com.apple.automator-type-definition"
  | "com.apple.automator-workflow"
  | "com.apple.avatarkit.animoji"
  | "com.apple.binary-property-list"
  | "com.apple.binhex-archive"
  | "com.apple.bom-archive"
  | "com.apple.bom-compressed-cpio"
  | "com.apple.bonjour"
  | "com.apple.bookmark"
  | "com.apple.bundle"
  | "com.apple.calendar-store.calendar"
  | "com.apple.calendar-store.event"
  | "com.apple.calendar-store.item"
  | "com.apple.calendar-store.todo"
  | "com.apple.cfr-font"
  | "com.apple.chess.game"
  | "com.apple.chess.pgn"
  | "com.apple.cinema-display"
  | "com.apple.clips-source"
  | "com.apple.cocoa.attributed-string"
  | "com.apple.cocoa.data"
  | "com.apple.cocoa.pasteboard.character-formatting"
  | "com.apple.cocoa.pasteboard.color"
  | "com.apple.cocoa.pasteboard.find-panel-search-options"
  | "com.apple.cocoa.pasteboard.multiple-text-selection"
  | "com.apple.cocoa.pasteboard.paragraph-formatting"
  | "com.apple.cocoa.pasteboard.sound"
  | "com.apple.cocoa.path"
  | "com.apple.cocoa.string"
  | "com.apple.cocoa.url"
  | "com.apple.cocoa.web-archive"
  | "com.apple.color-file"
  | "com.apple.colorsync-profile"
  | "com.apple.configprofile"
  | "com.apple.coreaudio-format"
  | "com.apple.coreml.mlarchive"
  | "com.apple.coreml.mlmodelc"
  | "com.apple.coreml.mlmodelkey"
  | "com.apple.coreml.mlpackage"
  | "com.apple.coreml.model"
  | "com.apple.coresimulator.bundle"
  | "com.apple.coresimulator.simdevicechrome"
  | "com.apple.coresimulator.simdevicetype"
  | "com.apple.coresimulator.simdeviceuserinterface"
  | "com.apple.coresimulator.simruntime"
  | "com.apple.crashreport"
  | "com.apple.createml.project"
  | "com.apple.csstore"
  | "com.apple.dashboard-widget"
  | "com.apple.data-container"
  | "com.apple.deprecated-application-file"
  | "com.apple.desktop-folder"
  | "com.apple.developer-folder"
  | "com.apple.developer-transition-kit-2005"
  | "com.apple.developer-transition-kit-2020"
  | "com.apple.device"
  | "com.apple.device-model-code"
  | "com.apple.disk-image"
  | "com.apple.disk-image-cdr"
  | "com.apple.disk-image-pc"
  | "com.apple.disk-image-raw"
  | "com.apple.disk-image-sparse"
  | "com.apple.disk-image-sparse-bundle"
  | "com.apple.disk-image-udif"
  | "com.apple.disk-image-udif-segment"
  | "com.apple.document-type"
  | "com.apple.document-type.dictionary"
  | "com.apple.document-type.system-folder"
  | "com.apple.documentation.doccarchive"
  | "com.apple.documentation.tutorial"
  | "com.apple.documents-folder"
  | "com.apple.dot-mac"
  | "com.apple.downloads-folder"
  | "com.apple.drawing"
  | "com.apple.driver-extension"
  | "com.apple.drop-folder"
  | "com.apple.dt.assetcatalog"
  | "com.apple.dt.bundle.unit-test"
  | "com.apple.dt.bundle.unit-test.ocunit"
  | "com.apple.dt.bundle.unit-test.xctest"
  | "com.apple.dt.document.apns"
  | "com.apple.dt.document.ascii-property-list"
  | "com.apple.dt.document.geojson"
  | "com.apple.dt.document.gpx"
  | "com.apple.dt.document.scheme"
  | "com.apple.dt.document.script-suite-property-list"
  | "com.apple.dt.document.script-terminology-property-list"
  | "com.apple.dt.document.snapshot"
  | "com.apple.dt.document.toolchain"
  | "com.apple.dt.document.workspace"
  | "com.apple.dt.document.xccrashpoint"
  | "com.apple.dt.document.xcdiskwritelog"
  | "com.apple.dt.document.xcdiskwritepoint"
  | "com.apple.dt.document.xcmetricsdata"
  | "com.apple.dt.document.xcprocessorusagelog"
  | "com.apple.dt.document.xcprocessorusagepoint"
  | "com.apple.dt.dvt.plug-in"
  | "com.apple.dt.dvticon.spec"
  | "com.apple.dt.ide.debughierarchycontenttype"
  | "com.apple.dt.ide.memorygraphdebuggercontenttype"
  | "com.apple.dt.ide.plug-in"
  | "com.apple.dt.interfacebuilder.document.storyboard"
  | "com.apple.dt.interfacebuilder.document.storyboard.package"
  | "com.apple.dt.messages-sticker-pack"
  | "com.apple.dt.playground"
  | "com.apple.dt.playgroundpage"
  | "com.apple.dt.sample.txt"
  | "com.apple.dt.stickers"
  | "com.apple.dt.storekit"
  | "com.apple.dt.xcodeserver-integration"
  | "com.apple.dt.xctestplancontenttype"
  | "com.apple.dt.xctestruncontenttype"
  | "com.apple.emac"
  | "com.apple.encrypted-archive"
  | "com.apple.event-kit.calendar"
  | "com.apple.event-kit.event"
  | "com.apple.event-kit.item"
  | "com.apple.event-kit.reminder"
  | "com.apple.everyone-icon"
  | "com.apple.file-internet-location"
  | "com.apple.file-server"
  | "com.apple.file-system-plug-in"
  | "com.apple.file-vault"
  | "com.apple.finalcutpro.colorboard"
  | "com.apple.finalcutpro.xml"
  | "com.apple.finder.burn-folder"
  | "com.apple.finder.clipping"
  | "com.apple.finder.file-or-folder-object"
  | "com.apple.finder.pictclipping"
  | "com.apple.finder.predefined-search"
  | "com.apple.finder.recent-items"
  | "com.apple.finder.smart-folder"
  | "com.apple.finder.sound-clipping"
  | "com.apple.finder.textclipping"
  | "com.apple.flat-rtfd"
  | "com.apple.font-suitcase"
  | "com.apple.fontbook.font-collection-object"
  | "com.apple.fontbook.typeface-object"
  | "com.apple.framework"
  | "com.apple.ftp-internet-location"
  | "com.apple.garageband.project"
  | "com.apple.garageband.template.magic"
  | "com.apple.garageband.template.magicmentor"
  | "com.apple.generic-airdisk"
  | "com.apple.generic-bundle"
  | "com.apple.generic-internet-location"
  | "com.apple.generic-stationery"
  | "com.apple.generic-time-machine-disk"
  | "com.apple.gpurestart"
  | "com.apple.gputools.gputrace"
  | "com.apple.gputools.gtdbg"
  | "com.apple.groupactivities.activity"
  | "com.apple.groups-folder"
  | "com.apple.guest-user"
  | "com.apple.hangreport"
  | "com.apple.haptics.ahap"
  | "com.apple.help-document"
  | "com.apple.home-folder"
  | "com.apple.homebuttonless-device"
  | "com.apple.homebuttonless-ipad"
  | "com.apple.homebuttonless-iphone"
  | "com.apple.homepod"
  | "com.apple.homepod-1"
  | "com.apple.homepod-2"
  | "com.apple.homepod-mini"
  | "com.apple.homepod-mini-1"
  | "com.apple.homepod-mini-2"
  | "com.apple.ibook-g4"
  | "com.apple.ibooks"
  | "com.apple.ibooks-container"
  | "com.apple.ibooks-folder"
  | "com.apple.ibooks.epub"
  | "com.apple.ibooksauthor.book"
  | "com.apple.ibooksauthor.pkgbook"
  | "com.apple.ibooksauthor.pkgtemplate"
  | "com.apple.ibooksauthor.template"
  | "com.apple.ical.backup-package"
  | "com.apple.ical.calendar-object"
  | "com.apple.ical.event-object"
  | "com.apple.ical.ics"
  | "com.apple.ical.ics.event"
  | "com.apple.ical.ics.todo"
  | "com.apple.ical.item-object"
  | "com.apple.ical.todo-object"
  | "com.apple.ical.vcs"
  | "com.apple.icloud"
  | "com.apple.icloud-file-fault"
  | "com.apple.icns"
  | "com.apple.icon-decoration"
  | "com.apple.icon-decoration-position"
  | "com.apple.icon-decoration-position.center"
  | "com.apple.icon-decoration-position.leading-bottom"
  | "com.apple.icon-decoration-position.overlay"
  | "com.apple.icon-decoration-position.trailing-bottom"
  | "com.apple.icon-decoration.badge"
  | "com.apple.icon-decoration.badge.checkmark"
  | "com.apple.icon-decoration.badge.comments"
  | "com.apple.icon-decoration.badge.drop-folder"
  | "com.apple.icon-decoration.badge.heart"
  | "com.apple.icon-decoration.badge.in-review"
  | "com.apple.icon-decoration.badge.locked"
  | "com.apple.icon-decoration.badge.locked-by-collaborator"
  | "com.apple.icon-decoration.badge.locked-by-user"
  | "com.apple.icon-decoration.badge.pinned"
  | "com.apple.icon-decoration.badge.private-folder"
  | "com.apple.icon-decoration.badge.syncing"
  | "com.apple.icon-decoration.badge.trending"
  | "com.apple.icon-decoration.badge.warning"
  | "com.apple.icon-decoration.emboss"
  | "com.apple.icon-decoration.system"
  | "com.apple.icon-decoration.system.alias"
  | "com.apple.icon-decoration.system.caution-alert"
  | "com.apple.icon-decoration.system.new-folder"
  | "com.apple.icon-decoration.system.unsupported"
  | "com.apple.icon-overlay.alert-caution-badge"
  | "com.apple.icon-overlay.alias-badge"
  | "com.apple.icon-overlay.drop-folder-badge"
  | "com.apple.icon-overlay.locked-badge"
  | "com.apple.icon-overlay.new-folder-badge"
  | "com.apple.icon-overlay.private-folder"
  | "com.apple.icon-overlay.private-folder-badge"
  | "com.apple.icon-overlay.unsupported-badge"
  | "com.apple.iconset"
  | "com.apple.idisk"
  | "com.apple.idvd.item-object"
  | "com.apple.idvd.menu-object"
  | "com.apple.idvd.slideshow-object"
  | "com.apple.iig-source"
  | "com.apple.ilifemediabrowser.plugin"
  | "com.apple.imac"
  | "com.apple.imac-15-1"
  | "com.apple.imac-2021"
  | "com.apple.imac-2021-blue"
  | "com.apple.imac-2021-green"
  | "com.apple.imac-2021-orange"
  | "com.apple.imac-2021-purple"
  | "com.apple.imac-2021-red"
  | "com.apple.imac-2021-silver"
  | "com.apple.imac-2021-yellow"
  | "com.apple.imac-aluminum-20"
  | "com.apple.imac-aluminum-24"
  | "com.apple.imac-core-2-duo"
  | "com.apple.imac-core-duo"
  | "com.apple.imac-g4-15"
  | "com.apple.imac-g4-17"
  | "com.apple.imac-g4-20"
  | "com.apple.imac-g5"
  | "com.apple.imac-g5-isight"
  | "com.apple.imac-isight-24"
  | "com.apple.imac-unibody"
  | "com.apple.imac-unibody-21"
  | "com.apple.imac-unibody-21-no-optical"
  | "com.apple.imac-unibody-21-no-optical-2017"
  | "com.apple.imac-unibody-21-no-optical-2019"
  | "com.apple.imac-unibody-21-no-optical.mid-2015"
  | "com.apple.imac-unibody-27-no-optical"
  | "com.apple.imac-unibody-27-no-optical-2017"
  | "com.apple.imac-unibody-27-no-optical-2019"
  | "com.apple.imac-unibody-27-no-optical-2020"
  | "com.apple.imac-unibody-27-no-optical-late-2015"
  | "com.apple.imacpro-2017"
  | "com.apple.imovie.imoviemobile"
  | "com.apple.imovie.imovietrailer"
  | "com.apple.imovieevent"
  | "com.apple.imovielibrary"
  | "com.apple.imovieproject"
  | "com.apple.imovietheater"
  | "com.apple.ink.inktext"
  | "com.apple.installer-distribution-package"
  | "com.apple.installer-meta-package"
  | "com.apple.installer-package"
  | "com.apple.installer-package-archive"
  | "com.apple.instruments.instrdst"
  | "com.apple.instruments.package-definition"
  | "com.apple.instruments.prototrace"
  | "com.apple.instruments.trace"
  | "com.apple.instruments.tracetemplate"
  | "com.apple.intelligentsuggestions.assets"
  | "com.apple.interfacebuilder.document"
  | "com.apple.interfacebuilder.document.cocoa"
  | "com.apple.interfacebuilder.plugin"
  | "com.apple.internet-location"
  | "com.apple.ios-device"
  | "com.apple.ios-simulator"
  | "com.apple.ipad"
  | "com.apple.ipad-2-black"
  | "com.apple.ipad-2-cdma-black"
  | "com.apple.ipad-2-cdma-white"
  | "com.apple.ipad-2-gsm-black"
  | "com.apple.ipad-2-gsm-white"
  | "com.apple.ipad-2-white"
  | "com.apple.ipad-2a-black"
  | "com.apple.ipad-2a-white"
  | "com.apple.ipad-3-4g-cdma-black"
  | "com.apple.ipad-3-4g-cdma-white"
  | "com.apple.ipad-3-4g-gsm-black"
  | "com.apple.ipad-3-4g-gsm-white"
  | "com.apple.ipad-3-black"
  | "com.apple.ipad-3-white"
  | "com.apple.ipad-4-a1458-black"
  | "com.apple.ipad-4-a1458-white"
  | "com.apple.ipad-4-a1459-black"
  | "com.apple.ipad-4-a1459-white"
  | "com.apple.ipad-4-a1460-black"
  | "com.apple.ipad-4-a1460-white"
  | "com.apple.ipad-6-a1893-1"
  | "com.apple.ipad-6-a1893-2"
  | "com.apple.ipad-6-a1893-3"
  | "com.apple.ipad-6-a1954-1"
  | "com.apple.ipad-6-a1954-2"
  | "com.apple.ipad-6-a1954-3"
  | "com.apple.ipad-7-wifi-1"
  | "com.apple.ipad-7-wifi-2"
  | "com.apple.ipad-7-wifi-3"
  | "com.apple.ipad-7-wwan-1"
  | "com.apple.ipad-7-wwan-2"
  | "com.apple.ipad-7-wwan-3"
  | "com.apple.ipad-8-wifi-1"
  | "com.apple.ipad-8-wifi-2"
  | "com.apple.ipad-8-wifi-3"
  | "com.apple.ipad-8-wwan-1"
  | "com.apple.ipad-8-wwan-2"
  | "com.apple.ipad-8-wwan-3"
  | "com.apple.ipad-air-a1474-99989b"
  | "com.apple.ipad-air-a1474-d7d9d8"
  | "com.apple.ipad-air-a1475-99989b"
  | "com.apple.ipad-air-a1475-d7d9d8"
  | "com.apple.ipad-air-a1476-99989b"
  | "com.apple.ipad-air-a1476-d7d9d8"
  | "com.apple.ipad-air2-a1566-b4b5b9"
  | "com.apple.ipad-air2-a1566-d7d9d8"
  | "com.apple.ipad-air2-a1566-e1ccb5"
  | "com.apple.ipad-air2-a1567-b4b5b9"
  | "com.apple.ipad-air2-a1567-d7d9d8"
  | "com.apple.ipad-air2-a1567-e1ccb5"
  | "com.apple.ipad-air3-wifi-1"
  | "com.apple.ipad-air3-wifi-2"
  | "com.apple.ipad-air3-wifi-3"
  | "com.apple.ipad-air3-wwan-1"
  | "com.apple.ipad-air3-wwan-2"
  | "com.apple.ipad-air3-wwan-3"
  | "com.apple.ipad-air4-1"
  | "com.apple.ipad-air4-2"
  | "com.apple.ipad-air4-3"
  | "com.apple.ipad-air4-4"
  | "com.apple.ipad-air4-5"
  | "com.apple.ipad-gen5-a1822-1"
  | "com.apple.ipad-gen5-a1822-2"
  | "com.apple.ipad-gen5-a1822-3"
  | "com.apple.ipad-gen5-a1823-1"
  | "com.apple.ipad-gen5-a1823-2"
  | "com.apple.ipad-gen5-a1823-3"
  | "com.apple.ipad-mini-3g-a1454-black"
  | "com.apple.ipad-mini-3g-a1454-white"
  | "com.apple.ipad-mini-3g-a1455-black"
  | "com.apple.ipad-mini-3g-a1455-white"
  | "com.apple.ipad-mini-black"
  | "com.apple.ipad-mini-white"
  | "com.apple.ipad-mini2-a1489-99989b"
  | "com.apple.ipad-mini2-a1489-d7d9d8"
  | "com.apple.ipad-mini2-a1490-99989b"
  | "com.apple.ipad-mini2-a1490-d7d9d8"
  | "com.apple.ipad-mini2-a1491-99989b"
  | "com.apple.ipad-mini2-a1491-d7d9d8"
  | "com.apple.ipad-mini3-a1599-b4b5b9"
  | "com.apple.ipad-mini3-a1599-d7d9d8"
  | "com.apple.ipad-mini3-a1599-e1ccb5"
  | "com.apple.ipad-mini3-a1600-b4b5b9"
  | "com.apple.ipad-mini3-a1600-d7d9d8"
  | "com.apple.ipad-mini3-a1600-e1ccb5"
  | "com.apple.ipad-mini3-a1601-b4b5b9"
  | "com.apple.ipad-mini3-a1601-d7d9d8"
  | "com.apple.ipad-mini3-a1601-e1ccb5"
  | "com.apple.ipad-mini4-a1538-b4b5b9"
  | "com.apple.ipad-mini4-a1538-d7d9d8"
  | "com.apple.ipad-mini4-a1538-e1ccb5"
  | "com.apple.ipad-mini4-a1550-b4b5b9"
  | "com.apple.ipad-mini4-a1550-d7d9d8"
  | "com.apple.ipad-mini4-a1550-e1ccb5"
  | "com.apple.ipad-mini5-wifi-1"
  | "com.apple.ipad-mini5-wifi-2"
  | "com.apple.ipad-mini5-wifi-3"
  | "com.apple.ipad-mini5-wwan-1"
  | "com.apple.ipad-mini5-wwan-2"
  | "com.apple.ipad-mini5-wwan-3"
  | "com.apple.ipad-pro-10point5-a1701-1"
  | "com.apple.ipad-pro-10point5-a1701-2"
  | "com.apple.ipad-pro-10point5-a1701-3"
  | "com.apple.ipad-pro-10point5-a1701-4"
  | "com.apple.ipad-pro-10point5-a1709-1"
  | "com.apple.ipad-pro-10point5-a1709-2"
  | "com.apple.ipad-pro-10point5-a1709-3"
  | "com.apple.ipad-pro-10point5-a1709-4"
  | "com.apple.ipad-pro-11-1"
  | "com.apple.ipad-pro-11-2"
  | "com.apple.ipad-pro-11-2nd-1"
  | "com.apple.ipad-pro-11-2nd-2"
  | "com.apple.ipad-pro-11-3rd-1"
  | "com.apple.ipad-pro-11-3rd-2"
  | "com.apple.ipad-pro-12point9-1"
  | "com.apple.ipad-pro-12point9-2"
  | "com.apple.ipad-pro-12point9-4th-1"
  | "com.apple.ipad-pro-12point9-4th-2"
  | "com.apple.ipad-pro-12point9-5th-1"
  | "com.apple.ipad-pro-12point9-5th-2"
  | "com.apple.ipad-pro-9point7-a1673-b9b7ba"
  | "com.apple.ipad-pro-9point7-a1673-dadcdb"
  | "com.apple.ipad-pro-9point7-a1673-e1ccb7"
  | "com.apple.ipad-pro-9point7-a1673-e4c1b9"
  | "com.apple.ipad-pro-9point7-a1674-b9b7ba"
  | "com.apple.ipad-pro-9point7-a1674-dadcdb"
  | "com.apple.ipad-pro-9point7-a1674-e1ccb7"
  | "com.apple.ipad-pro-9point7-a1674-e4c1b9"
  | "com.apple.ipad-pro-a1584-b4b5b9"
  | "com.apple.ipad-pro-a1584-d7d9d8"
  | "com.apple.ipad-pro-a1584-e1ccb5"
  | "com.apple.ipad-pro-a1652-b4b5b9"
  | "com.apple.ipad-pro-a1652-d7d9d8"
  | "com.apple.ipad-pro-a1652-e1ccb5"
  | "com.apple.ipad-pro-a1670-1"
  | "com.apple.ipad-pro-a1670-2"
  | "com.apple.ipad-pro-a1670-3"
  | "com.apple.ipad-pro-a1821-1"
  | "com.apple.ipad-pro-a1821-2"
  | "com.apple.ipad-pro-a1821-3"
  | "com.apple.iphone"
  | "com.apple.iphone-11-1"
  | "com.apple.iphone-11-11"
  | "com.apple.iphone-11-12"
  | "com.apple.iphone-11-2"
  | "com.apple.iphone-11-6"
  | "com.apple.iphone-11-7"
  | "com.apple.iphone-11-pro-1"
  | "com.apple.iphone-11-pro-12"
  | "com.apple.iphone-11-pro-2"
  | "com.apple.iphone-11-pro-4"
  | "com.apple.iphone-11-pro-max-1"
  | "com.apple.iphone-11-pro-max-12"
  | "com.apple.iphone-11-pro-max-2"
  | "com.apple.iphone-11-pro-max-4"
  | "com.apple.iphone-12-1"
  | "com.apple.iphone-12-11"
  | "com.apple.iphone-12-18"
  | "com.apple.iphone-12-2"
  | "com.apple.iphone-12-6"
  | "com.apple.iphone-12-9"
  | "com.apple.iphone-12-mini-1"
  | "com.apple.iphone-12-mini-11"
  | "com.apple.iphone-12-mini-18"
  | "com.apple.iphone-12-mini-2"
  | "com.apple.iphone-12-mini-6"
  | "com.apple.iphone-12-mini-9"
  | "com.apple.iphone-12-pro-1"
  | "com.apple.iphone-12-pro-2"
  | "com.apple.iphone-12-pro-3"
  | "com.apple.iphone-12-pro-9"
  | "com.apple.iphone-12-pro-max-1"
  | "com.apple.iphone-12-pro-max-2"
  | "com.apple.iphone-12-pro-max-3"
  | "com.apple.iphone-12-pro-max-9"
  | "com.apple.iphone-3g"
  | "com.apple.iphone-3gs"
  | "com.apple.iphone-4"
  | "com.apple.iphone-4-black"
  | "com.apple.iphone-4-cdma-black"
  | "com.apple.iphone-4-cdma-white"
  | "com.apple.iphone-4-white"
  | "com.apple.iphone-4b-black"
  | "com.apple.iphone-4b-white"
  | "com.apple.iphone-4s-black"
  | "com.apple.iphone-4s-white"
  | "com.apple.iphone-5-a1428-3b3b3c"
  | "com.apple.iphone-5-a1428-black"
  | "com.apple.iphone-5-a1428-e1e4e3"
  | "com.apple.iphone-5-a1428-white"
  | "com.apple.iphone-5-a1429-3b3b3c"
  | "com.apple.iphone-5-a1429-black"
  | "com.apple.iphone-5-a1429-e1e4e3"
  | "com.apple.iphone-5-a1429-white"
  | "com.apple.iphone-5c-a1456-46abe0"
  | "com.apple.iphone-5c-a1456-a1e877"
  | "com.apple.iphone-5c-a1456-f5f4f7"
  | "com.apple.iphone-5c-a1456-faf189"
  | "com.apple.iphone-5c-a1456-fe767a"
  | "com.apple.iphone-5c-a1507-46abe0"
  | "com.apple.iphone-5c-a1507-a1e877"
  | "com.apple.iphone-5c-a1507-f5f4f7"
  | "com.apple.iphone-5c-a1507-faf189"
  | "com.apple.iphone-5c-a1507-fe767a"
  | "com.apple.iphone-5s-a1453-99989b"
  | "com.apple.iphone-5s-a1453-d4c5b3"
  | "com.apple.iphone-5s-a1453-d7d9d8"
  | "com.apple.iphone-5s-a1457-99989b"
  | "com.apple.iphone-5s-a1457-d4c5b3"
  | "com.apple.iphone-5s-a1457-d7d9d8"
  | "com.apple.iphone-6-b4b5b9"
  | "com.apple.iphone-6-d7d9d8"
  | "com.apple.iphone-6-e1ccb5"
  | "com.apple.iphone-6-plus-b4b5b9"
  | "com.apple.iphone-6-plus-d7d9d8"
  | "com.apple.iphone-6-plus-e1ccb5"
  | "com.apple.iphone-6s-b9b7ba"
  | "com.apple.iphone-6s-dadcdb"
  | "com.apple.iphone-6s-e1ccb7"
  | "com.apple.iphone-6s-e4c1b9"
  | "com.apple.iphone-6s-plus-b9b7ba"
  | "com.apple.iphone-6s-plus-dadcdb"
  | "com.apple.iphone-6s-plus-e1ccb7"
  | "com.apple.iphone-6s-plus-e4c1b9"
  | "com.apple.iphone-7-1"
  | "com.apple.iphone-7-2"
  | "com.apple.iphone-7-3"
  | "com.apple.iphone-7-4"
  | "com.apple.iphone-7-5"
  | "com.apple.iphone-7-6"
  | "com.apple.iphone-7-plus-1"
  | "com.apple.iphone-7-plus-2"
  | "com.apple.iphone-7-plus-3"
  | "com.apple.iphone-7-plus-4"
  | "com.apple.iphone-7-plus-5"
  | "com.apple.iphone-7-plus-6"
  | "com.apple.iphone-8"
  | "com.apple.iphone-8-2"
  | "com.apple.iphone-8-6"
  | "com.apple.iphone-8-7"
  | "com.apple.iphone-8-8"
  | "com.apple.iphone-8-plus"
  | "com.apple.iphone-8-plus-1"
  | "com.apple.iphone-8-plus-2"
  | "com.apple.iphone-8-plus-3"
  | "com.apple.iphone-8-plus-6"
  | "com.apple.iphone-se-1"
  | "com.apple.iphone-se-2"
  | "com.apple.iphone-se-6"
  | "com.apple.iphone-se-a1662-aeb1b8"
  | "com.apple.iphone-se-a1662-d6c8b9"
  | "com.apple.iphone-se-a1662-dcdede"
  | "com.apple.iphone-se-a1662-e5bdb5"
  | "com.apple.iphone-x"
  | "com.apple.iphone-x-1"
  | "com.apple.iphone-x-2"
  | "com.apple.iphone-xr-1"
  | "com.apple.iphone-xr-2"
  | "com.apple.iphone-xr-6"
  | "com.apple.iphone-xr-7"
  | "com.apple.iphone-xr-8"
  | "com.apple.iphone-xr-9"
  | "com.apple.iphone-xs-1"
  | "com.apple.iphone-xs-2"
  | "com.apple.iphone-xs-4"
  | "com.apple.iphone-xs-max-1"
  | "com.apple.iphone-xs-max-2"
  | "com.apple.iphone-xs-max-4"
  | "com.apple.iphone.developerprofile"
  | "com.apple.iphone.ipsw"
  | "com.apple.iphoto.album-object"
  | "com.apple.iphoto.ipmeta"
  | "com.apple.iphoto.ipspot"
  | "com.apple.iphoto.item-object"
  | "com.apple.iphoto.photo-object"
  | "com.apple.ipod"
  | "com.apple.ipod-classic"
  | "com.apple.ipod-mini"
  | "com.apple.ipod-nano"
  | "com.apple.ipod-shuffle"
  | "com.apple.ipod-shuffle-gen1"
  | "com.apple.ipod-shuffle-gen2"
  | "com.apple.ipod-shuffle-gen3"
  | "com.apple.ipod-shuffle-gen4"
  | "com.apple.ipod-touch"
  | "com.apple.ipod-touch-2"
  | "com.apple.ipod-touch-3"
  | "com.apple.ipod-touch-4"
  | "com.apple.ipod-touch-4-black"
  | "com.apple.ipod-touch-4-white"
  | "com.apple.ipod-touch-5-blue"
  | "com.apple.ipod-touch-5-pink"
  | "com.apple.ipod-touch-5-red"
  | "com.apple.ipod-touch-5-silver"
  | "com.apple.ipod-touch-5-slate"
  | "com.apple.ipod-touch-5-sparrow"
  | "com.apple.ipod-touch-5-white"
  | "com.apple.ipod-touch-5-yellow"
  | "com.apple.ipod-touch-6-458dce"
  | "com.apple.ipod-touch-6-6b6a6d"
  | "com.apple.ipod-touch-6-c6353f"
  | "com.apple.ipod-touch-6-dadcdb"
  | "com.apple.ipod-touch-6-e1ccb7"
  | "com.apple.ipod-touch-6-e75090"
  | "com.apple.ipod-touch-7-2"
  | "com.apple.ipod-touch-7-3"
  | "com.apple.ipod-touch-7-4"
  | "com.apple.ipod-touch-7-5"
  | "com.apple.ipod-touch-7-6"
  | "com.apple.ipod-touch-7-9"
  | "com.apple.ips"
  | "com.apple.itunes.db"
  | "com.apple.itunes.ipa"
  | "com.apple.itunes.ipsw"
  | "com.apple.itunes.item-object"
  | "com.apple.itunes.playlist-object"
  | "com.apple.itunes.source-object"
  | "com.apple.itunes.store-url"
  | "com.apple.itunes.track-object"
  | "com.apple.iwork.keynote.key"
  | "com.apple.iwork.keynote.key-tef"
  | "com.apple.iwork.keynote.kpdc"
  | "com.apple.iwork.keynote.kpf"
  | "com.apple.iwork.keynote.kth"
  | "com.apple.iwork.keynote.sffkey"
  | "com.apple.iwork.keynote.sffkth"
  | "com.apple.iwork.numbers.numbers"
  | "com.apple.iwork.numbers.numbers-tef"
  | "com.apple.iwork.numbers.sffnumbers"
  | "com.apple.iwork.numbers.sfftemplate"
  | "com.apple.iwork.numbers.template"
  | "com.apple.iwork.pages.pages"
  | "com.apple.iwork.pages.pages-tef"
  | "com.apple.iwork.pages.sffpages"
  | "com.apple.iwork.pages.sfftemplate"
  | "com.apple.iwork.pages.template"
  | "com.apple.json-crash"
  | "com.apple.kernel-extension"
  | "com.apple.keychain"
  | "com.apple.keynote.key"
  | "com.apple.keynote.kth"
  | "com.apple.ktrace"
  | "com.apple.led-cinema-display-24"
  | "com.apple.led-cinema-display-27"
  | "com.apple.legacy-ipod"
  | "com.apple.legacy.actions-icon"
  | "com.apple.legacy.backward-arrow"
  | "com.apple.legacy.burn"
  | "com.apple.legacy.clock-icon"
  | "com.apple.legacy.connect-to"
  | "com.apple.legacy.customize-toolbar"
  | "com.apple.legacy.delete-toolbar"
  | "com.apple.legacy.eject-media"
  | "com.apple.legacy.erasing"
  | "com.apple.legacy.favorite-items"
  | "com.apple.legacy.finder-icon"
  | "com.apple.legacy.forward-arrow"
  | "com.apple.legacy.general-icon"
  | "com.apple.legacy.grid"
  | "com.apple.legacy.keep-arranged"
  | "com.apple.legacy.locked"
  | "com.apple.legacy.magnifying-glass"
  | "com.apple.legacy.multiple-items"
  | "com.apple.legacy.no-write"
  | "com.apple.legacy.open-folder"
  | "com.apple.legacy.question-mark"
  | "com.apple.legacy.right-container-arrow"
  | "com.apple.legacy.sidebar-prefs-icon"
  | "com.apple.legacy.synchronize"
  | "com.apple.legacy.toolbar-advanced-icon"
  | "com.apple.legacy.toolbar-info-icon"
  | "com.apple.legacy.toolbar-labels-icon"
  | "com.apple.legacy.unlocked"
  | "com.apple.legacy.window"
  | "com.apple.library-folder"
  | "com.apple.live-photo"
  | "com.apple.live-photo-bundle"
  | "com.apple.localizable-name-bundle"
  | "com.apple.localized-pdf-bundle"
  | "com.apple.log"
  | "com.apple.logarchive"
  | "com.apple.logic-song"
  | "com.apple.logic.channelstripsetting"
  | "com.apple.logic.dpst"
  | "com.apple.logic.drummerlibrary"
  | "com.apple.logic.exs"
  | "com.apple.logic.gchdb"
  | "com.apple.logic.impulseresponse"
  | "com.apple.logic.keycommand"
  | "com.apple.logic.notator"
  | "com.apple.logic.pluginsetting"
  | "com.apple.logic.project"
  | "com.apple.logicx.project"
  | "com.apple.lsr-image"
  | "com.apple.m4a-audio"
  | "com.apple.m4v-video"
  | "com.apple.mac"
  | "com.apple.mac.laptop"
  | "com.apple.mac.rackmount"
  | "com.apple.mac.tower"
  | "com.apple.macbinary-archive"
  | "com.apple.macbook"
  | "com.apple.macbook-black"
  | "com.apple.macbook-retina"
  | "com.apple.macbook-retina-gold"
  | "com.apple.macbook-retina-gold-2017"
  | "com.apple.macbook-retina-gold-2018"
  | "com.apple.macbook-retina-rose-gold"
  | "com.apple.macbook-retina-rose-gold-2017"
  | "com.apple.macbook-retina-silver"
  | "com.apple.macbook-retina-silver-2017"
  | "com.apple.macbook-retina-space-gray"
  | "com.apple.macbook-retina-space-gray-2017"
  | "com.apple.macbook-unibody"
  | "com.apple.macbook-unibody-plastic"
  | "com.apple.macbook-white"
  | "com.apple.macbookair"
  | "com.apple.macbookair-11-unibody"
  | "com.apple.macbookair-13-unibody"
  | "com.apple.macbookair-2018"
  | "com.apple.macbookair-2018-gold"
  | "com.apple.macbookair-2018-silver"
  | "com.apple.macbookair-2018-space-gray"
  | "com.apple.macbookair-2019"
  | "com.apple.macbookair-2019-gold"
  | "com.apple.macbookair-2019-silver"
  | "com.apple.macbookair-2019-space-gray"
  | "com.apple.macbookair-2020"
  | "com.apple.macbookair-2020-gold"
  | "com.apple.macbookair-2020-silver"
  | "com.apple.macbookair-2020-space-gray"
  | "com.apple.macbookair-late-2020"
  | "com.apple.macbookair-late-2020-gold"
  | "com.apple.macbookair-late-2020-silver"
  | "com.apple.macbookair-late-2020-space-gray"
  | "com.apple.macbookpro"
  | "com.apple.macbookpro-13-retina-display"
  | "com.apple.macbookpro-13-retina-four-usb-ports-2020"
  | "com.apple.macbookpro-13-retina-four-usb-ports-silver-2020"
  | "com.apple.macbookpro-13-retina-four-usb-ports-space-gray-2020"
  | "com.apple.macbookpro-13-retina-touchid"
  | "com.apple.macbookpro-13-retina-touchid-2017"
  | "com.apple.macbookpro-13-retina-touchid-2018"
  | "com.apple.macbookpro-13-retina-touchid-2020"
  | "com.apple.macbookpro-13-retina-touchid-late-2020"
  | "com.apple.macbookpro-13-retina-touchid-silver"
  | "com.apple.macbookpro-13-retina-touchid-silver-2017"
  | "com.apple.macbookpro-13-retina-touchid-silver-2018"
  | "com.apple.macbookpro-13-retina-touchid-silver-2020"
  | "com.apple.macbookpro-13-retina-touchid-silver-late-2020"
  | "com.apple.macbookpro-13-retina-touchid-space-gray"
  | "com.apple.macbookpro-13-retina-touchid-space-gray-2017"
  | "com.apple.macbookpro-13-retina-touchid-space-gray-2018"
  | "com.apple.macbookpro-13-retina-touchid-space-gray-2020"
  | "com.apple.macbookpro-13-retina-touchid-space-gray-late-2020"
  | "com.apple.macbookpro-13-retina-usbc"
  | "com.apple.macbookpro-13-retina-usbc-2017"
  | "com.apple.macbookpro-13-retina-usbc-2019"
  | "com.apple.macbookpro-13-retina-usbc-silver"
  | "com.apple.macbookpro-13-retina-usbc-silver-2017"
  | "com.apple.macbookpro-13-retina-usbc-silver-2019"
  | "com.apple.macbookpro-13-retina-usbc-space-gray"
  | "com.apple.macbookpro-13-retina-usbc-space-gray-2017"
  | "com.apple.macbookpro-13-retina-usbc-space-gray-2019"
  | "com.apple.macbookpro-13-unibody"
  | "com.apple.macbookpro-15"
  | "com.apple.macbookpro-15-late-2018"
  | "com.apple.macbookpro-15-retina-display"
  | "com.apple.macbookpro-15-retina-touchid"
  | "com.apple.macbookpro-15-retina-touchid-2017"
  | "com.apple.macbookpro-15-retina-touchid-2018"
  | "com.apple.macbookpro-15-retina-touchid-silver"
  | "com.apple.macbookpro-15-retina-touchid-silver-2017"
  | "com.apple.macbookpro-15-retina-touchid-silver-2018"
  | "com.apple.macbookpro-15-retina-touchid-space-gray"
  | "com.apple.macbookpro-15-retina-touchid-space-gray-2017"
  | "com.apple.macbookpro-15-retina-touchid-space-gray-2018"
  | "com.apple.macbookpro-15-silver-late-2018"
  | "com.apple.macbookpro-15-space-gray-late-2018"
  | "com.apple.macbookpro-15-unibody"
  | "com.apple.macbookpro-16"
  | "com.apple.macbookpro-16-mid-2020"
  | "com.apple.macbookpro-16-silver"
  | "com.apple.macbookpro-16-silver-mid-2020"
  | "com.apple.macbookpro-16-space-gray"
  | "com.apple.macbookpro-16-space-gray-mid-2020"
  | "com.apple.macbookpro-17"
  | "com.apple.macbookpro-17-unibody"
  | "com.apple.mach-o-binary"
  | "com.apple.mach-o-bundle"
  | "com.apple.mach-o-core"
  | "com.apple.mach-o-dylib"
  | "com.apple.mach-o-executable"
  | "com.apple.mach-o-object"
  | "com.apple.macmini"
  | "com.apple.macmini-2018"
  | "com.apple.macmini-2020"
  | "com.apple.macmini-core-duo"
  | "com.apple.macmini-g4"
  | "com.apple.macmini-unibody"
  | "com.apple.macmini-unibody-no-optical"
  | "com.apple.macpaint-image"
  | "com.apple.macpro"
  | "com.apple.macpro-2019"
  | "com.apple.macpro-2019-rackmount"
  | "com.apple.macpro-cylinder"
  | "com.apple.macpro-firewire"
  | "com.apple.mail-internet-location"
  | "com.apple.mail.account-object"
  | "com.apple.mail.email"
  | "com.apple.mail.emlx"
  | "com.apple.mail.emlx.part"
  | "com.apple.mail.ewsmbox"
  | "com.apple.mail.imapmbox"
  | "com.apple.mail.item-object"
  | "com.apple.mail.mailbox-object"
  | "com.apple.mail.mbox"
  | "com.apple.mail.message-object"
  | "com.apple.mainstage.graph"
  | "com.apple.mainstage.patches"
  | "com.apple.mapkit.map-item"
  | "com.apple.maps.directionsrequest"
  | "com.apple.maps.navtracefile"
  | "com.apple.menu-extra"
  | "com.apple.messages.ckconversation"
  | "com.apple.metadata-importer"
  | "com.apple.metal"
  | "com.apple.migratedaplibrary"
  | "com.apple.migratedphotolibrary"
  | "com.apple.mobileconfig"
  | "com.apple.mobileprovision"
  | "com.apple.mount-point"
  | "com.apple.movie-folder"
  | "com.apple.mpeg-4-ringtone"
  | "com.apple.music-folder"
  | "com.apple.music.cdda"
  | "com.apple.music.database"
  | "com.apple.music.iappurl"
  | "com.apple.music.itlp"
  | "com.apple.music.itms"
  | "com.apple.music.library"
  | "com.apple.music.m3u-playlist"
  | "com.apple.music.metadata"
  | "com.apple.music.mp2"
  | "com.apple.music.pls-playlist"
  | "com.apple.music.rmp-playlist"
  | "com.apple.music.visual"
  | "com.apple.network-neighborhood"
  | "com.apple.news-internet-location"
  | "com.apple.not-loaded"
  | "com.apple.notes.airdrop.document"
  | "com.apple.notes.archive"
  | "com.apple.notes.gallery"
  | "com.apple.notes.inlinetextattachment"
  | "com.apple.notes.inlinetextattachment.hashtag"
  | "com.apple.notes.inlinetextattachment.mention"
  | "com.apple.notes.note"
  | "com.apple.notes.richtext"
  | "com.apple.notes.sketch"
  | "com.apple.notes.spotlightrecord"
  | "com.apple.notes.table"
  | "com.apple.notifications"
  | "com.apple.nspboard-type"
  | "com.apple.ostype"
  | "com.apple.otc-font"
  | "com.apple.package"
  | "com.apple.panicreport"
  | "com.apple.paper"
  | "com.apple.pasteboard.promised-file-content-type"
  | "com.apple.pasteboard.promised-file-url"
  | "com.apple.pdf-printer-settings"
  | "com.apple.pef-binary"
  | "com.apple.perf.tailspin"
  | "com.apple.photo-booth-library"
  | "com.apple.photo.library"
  | "com.apple.photos.album-object"
  | "com.apple.photos.apple-adjustment-envelope"
  | "com.apple.photos.asset-bundle"
  | "com.apple.photos.folder-object"
  | "com.apple.photos.item-object"
  | "com.apple.photos.library"
  | "com.apple.photos.mediaitem-object"
  | "com.apple.photos.object-reference"
  | "com.apple.photos.object-reference.asset"
  | "com.apple.photos.object-reference.assetcollection"
  | "com.apple.photos.object-reference.collection"
  | "com.apple.photos.object-reference.collectionlist"
  | "com.apple.photos.object-reference.person"
  | "com.apple.photos.projects"
  | "com.apple.photos.projects.legacy.book"
  | "com.apple.photos.projects.legacy.calendar"
  | "com.apple.photos.projects.legacy.card"
  | "com.apple.photos.projects.legacy.keepsake"
  | "com.apple.photos.projects.legacy.prints"
  | "com.apple.photos.projects.slideshow"
  | "com.apple.photos.slow-motion-video-sidecar"
  | "com.apple.pict"
  | "com.apple.pictures-folder"
  | "com.apple.pkpass"
  | "com.apple.pkpass-data"
  | "com.apple.pkpasses-data"
  | "com.apple.playgroundbook"
  | "com.apple.playgroundbook.diffpack"
  | "com.apple.plugin"
  | "com.apple.pluginkit"
  | "com.apple.podcasts.episode"
  | "com.apple.podcasts.show"
  | "com.apple.podcasts.station"
  | "com.apple.powerbook"
  | "com.apple.powerbook-g4-12"
  | "com.apple.powerbook-g4-15"
  | "com.apple.powerbook-g4-17"
  | "com.apple.powerbook-g4-titanium"
  | "com.apple.powermac"
  | "com.apple.powermac-g4-mirrored-drive-doors"
  | "com.apple.powermac-g4-quicksilver"
  | "com.apple.powermac-g5"
  | "com.apple.ppp-plug-in"
  | "com.apple.preference.network"
  | "com.apple.preview.blank"
  | "com.apple.private.live-photo-bundle"
  | "com.apple.pro-display-xdr"
  | "com.apple.profile-background-color"
  | "com.apple.profile-font-and-color"
  | "com.apple.profile-font-icon"
  | "com.apple.property-list"
  | "com.apple.protected-mpeg-4-audio"
  | "com.apple.protected-mpeg-4-audio-b"
  | "com.apple.protected-mpeg-4-video"
  | "com.apple.provisionprofile"
  | "com.apple.public-folder"
  | "com.apple.pubsub.entry"
  | "com.apple.pubsub.feed"
  | "com.apple.quartz-composer-composition"
  | "com.apple.quicklook-generator"
  | "com.apple.quicktime-image"
  | "com.apple.quicktime-movie"
  | "com.apple.quicktimeplayerx-composition"
  | "com.apple.quicktimeplayerx-composition-bundle"
  | "com.apple.rcproject"
  | "com.apple.reality"
  | "com.apple.remotedesktop.computer-object"
  | "com.apple.resolvable"
  | "com.apple.rez-source"
  | "com.apple.rtfd"
  | "com.apple.safari.bookmark"
  | "com.apple.safari.document-object"
  | "com.apple.safari.extension"
  | "com.apple.safari.history"
  | "com.apple.scenekit.assetcatalog"
  | "com.apple.scenekit.particlesystem"
  | "com.apple.scenekit.scene"
  | "com.apple.scenekit.scene.zip"
  | "com.apple.scenekit.shadercache"
  | "com.apple.scripting-definition"
  | "com.apple.server-applications-folder"
  | "com.apple.servers-folder"
  | "com.apple.service-application"
  | "com.apple.shazamcatalog"
  | "com.apple.shazamsignature"
  | "com.apple.shortcut"
  | "com.apple.shortcuts.action"
  | "com.apple.shortcuts.workflow-file"
  | "com.apple.shutdownstall"
  | "com.apple.sirikit.intentdefinition"
  | "com.apple.sites-folder"
  | "com.apple.spinreport"
  | "com.apple.spotlight.item"
  | "com.apple.spritekit.serialized"
  | "com.apple.stickies.appexport"
  | "com.apple.storage-external"
  | "com.apple.storage-internal"
  | "com.apple.storage-netboot"
  | "com.apple.storage-removable"
  | "com.apple.structured-text"
  | "com.apple.structured-text.address"
  | "com.apple.structured-text.date"
  | "com.apple.structured-text.telephone-number"
  | "com.apple.structured-text.transit-information"
  | "com.apple.symbol-export"
  | "com.apple.system-extension"
  | "com.apple.systempreference.prefpane"
  | "com.apple.systempreference.prefpane.extension"
  | "com.apple.systempreference.screen-saver"
  | "com.apple.systempreference.screen-slide-saver"
  | "com.apple.systemprofiler.document"
  | "com.apple.terminal.session"
  | "com.apple.terminal.settings"
  | "com.apple.terminal.shell-script"
  | "com.apple.text-based-dylib"
  | "com.apple.textedit.document-object"
  | "com.apple.time-capsule"
  | "com.apple.traditional-mac-plain-text"
  | "com.apple.trash-empty"
  | "com.apple.trash-full"
  | "com.apple.truetype-datafork-suitcase-font"
  | "com.apple.tv.database"
  | "com.apple.tv.iappurl"
  | "com.apple.tv.ite"
  | "com.apple.tv.itms"
  | "com.apple.tv.library"
  | "com.apple.tv.m3u-playlist"
  | "com.apple.tv.metadata"
  | "com.apple.tv.movpkg"
  | "com.apple.txn.text-multimedia-data"
  | "com.apple.unknown-object"
  | "com.apple.user"
  | "com.apple.user-group"
  | "com.apple.user-idisk"
  | "com.apple.user-unknown"
  | "com.apple.users-folder"
  | "com.apple.utilities-folder"
  | "com.apple.vnc-internet-location"
  | "com.apple.voiceover-preferences"
  | "com.apple.watch"
  | "com.apple.watch-38mm-1"
  | "com.apple.watch-38mm-2"
  | "com.apple.watch-38mm-3"
  | "com.apple.watch-38mm-4"
  | "com.apple.watch-38mm-5"
  | "com.apple.watch-38mm-7"
  | "com.apple.watch-38mm-8"
  | "com.apple.watch-38mm-9"
  | "com.apple.watch-38mm-series1-1"
  | "com.apple.watch-38mm-series1-2"
  | "com.apple.watch-38mm-series1-3"
  | "com.apple.watch-38mm-series1-4"
  | "com.apple.watch-38mm-series1-5"
  | "com.apple.watch-38mm-series1-6"
  | "com.apple.watch-38mm-series2-1"
  | "com.apple.watch-38mm-series2-2"
  | "com.apple.watch-38mm-series2-3"
  | "com.apple.watch-38mm-series2-4"
  | "com.apple.watch-38mm-series2-5"
  | "com.apple.watch-38mm-series2-6"
  | "com.apple.watch-38mm-series2-7"
  | "com.apple.watch-38mm-series3-cell-1"
  | "com.apple.watch-38mm-series3-cell-11"
  | "com.apple.watch-38mm-series3-cell-13"
  | "com.apple.watch-38mm-series3-cell-2"
  | "com.apple.watch-38mm-series3-cell-5"
  | "com.apple.watch-38mm-series3-cell-6"
  | "com.apple.watch-38mm-series3-cell-7"
  | "com.apple.watch-38mm-series3-gps-1"
  | "com.apple.watch-38mm-series3-gps-11"
  | "com.apple.watch-38mm-series3-gps-13"
  | "com.apple.watch-38mm-series3-gps-2"
  | "com.apple.watch-38mm-series3-gps-5"
  | "com.apple.watch-38mm-series3-gps-6"
  | "com.apple.watch-38mm-series3-gps-7"
  | "com.apple.watch-42mm-1"
  | "com.apple.watch-42mm-2"
  | "com.apple.watch-42mm-3"
  | "com.apple.watch-42mm-4"
  | "com.apple.watch-42mm-5"
  | "com.apple.watch-42mm-7"
  | "com.apple.watch-42mm-8"
  | "com.apple.watch-42mm-9"
  | "com.apple.watch-42mm-series1-1"
  | "com.apple.watch-42mm-series1-2"
  | "com.apple.watch-42mm-series1-3"
  | "com.apple.watch-42mm-series1-4"
  | "com.apple.watch-42mm-series1-5"
  | "com.apple.watch-42mm-series1-6"
  | "com.apple.watch-42mm-series2-1"
  | "com.apple.watch-42mm-series2-2"
  | "com.apple.watch-42mm-series2-3"
  | "com.apple.watch-42mm-series2-4"
  | "com.apple.watch-42mm-series2-5"
  | "com.apple.watch-42mm-series2-6"
  | "com.apple.watch-42mm-series2-7"
  | "com.apple.watch-42mm-series3-cell-1"
  | "com.apple.watch-42mm-series3-cell-11"
  | "com.apple.watch-42mm-series3-cell-13"
  | "com.apple.watch-42mm-series3-cell-2"
  | "com.apple.watch-42mm-series3-cell-5"
  | "com.apple.watch-42mm-series3-cell-6"
  | "com.apple.watch-42mm-series3-cell-7"
  | "com.apple.watch-42mm-series3-gps-1"
  | "com.apple.watch-42mm-series3-gps-11"
  | "com.apple.watch-42mm-series3-gps-13"
  | "com.apple.watch-42mm-series3-gps-2"
  | "com.apple.watch-42mm-series3-gps-5"
  | "com.apple.watch-42mm-series3-gps-6"
  | "com.apple.watch-42mm-series3-gps-7"
  | "com.apple.watch-se-1"
  | "com.apple.watch-se-13"
  | "com.apple.watch-se-2"
  | "com.apple.watch-series4-1"
  | "com.apple.watch-series4-12"
  | "com.apple.watch-series4-13"
  | "com.apple.watch-series4-2"
  | "com.apple.watch-series4-5"
  | "com.apple.watch-series4-6"
  | "com.apple.watch-series5-1"
  | "com.apple.watch-series5-12"
  | "com.apple.watch-series5-13"
  | "com.apple.watch-series5-14"
  | "com.apple.watch-series5-2"
  | "com.apple.watch-series5-5"
  | "com.apple.watch-series5-6"
  | "com.apple.watch-series5-7"
  | "com.apple.watch-series5-8"
  | "com.apple.watch-series6-1"
  | "com.apple.watch-series6-12"
  | "com.apple.watch-series6-13"
  | "com.apple.watch-series6-14"
  | "com.apple.watch-series6-18"
  | "com.apple.watch-series6-2"
  | "com.apple.watch-series6-22"
  | "com.apple.watch-series6-26"
  | "com.apple.watch-series6-5"
  | "com.apple.watch-series6-6"
  | "com.apple.watch-series6-8"
  | "com.apple.watchface"
  | "com.apple.web-internet-location"
  | "com.apple.webarchive"
  | "com.apple.webkit-plugin"
  | "com.apple.widgetkit.simulator.document"
  | "com.apple.widgetkit.simulator.timeline"
  | "com.apple.wireless-diagnostics.wdmon"
  | "com.apple.wireless-diagnostics.wdsidecar"
  | "com.apple.x11-mach-o-executable"
  | "com.apple.xar-archive"
  | "com.apple.xcframework"
  | "com.apple.xcode.apinotes"
  | "com.apple.xcode.appdata"
  | "com.apple.xcode.archive"
  | "com.apple.xcode.bash-script"
  | "com.apple.xcode.buildmetrics"
  | "com.apple.xcode.configsettings"
  | "com.apple.xcode.csh-script"
  | "com.apple.xcode.docset"
  | "com.apple.xcode.dsym"
  | "com.apple.xcode.entitlements-property-list"
  | "com.apple.xcode.ksh-script"
  | "com.apple.xcode.model"
  | "com.apple.xcode.model.data"
  | "com.apple.xcode.model.data-mapping"
  | "com.apple.xcode.model.data-version"
  | "com.apple.xcode.mom"
  | "com.apple.xcode.plugin"
  | "com.apple.xcode.plugindata"
  | "com.apple.xcode.plugindata.compiled"
  | "com.apple.xcode.project"
  | "com.apple.xcode.projectdata"
  | "com.apple.xcode.resultbundle"
  | "com.apple.xcode.strings-dictionary"
  | "com.apple.xcode.strings-text"
  | "com.apple.xcode.tcsh-script"
  | "com.apple.xcode.usersettings"
  | "com.apple.xcode.xcfilelist"
  | "com.apple.xcode.xcloc"
  | "com.apple.xcode.yacc-source"
  | "com.apple.xcode.zsh-script"
  | "com.apple.xip-archive"
  | "com.apple.xml-property-list"
  | "com.apple.xpc-service"
  | "com.apple.xserve"
  | "com.apple.xserve-g4"
  | "com.apple.xserve-g5"
  | "com.apple.xserve-xeon"
  | "com.audible.aa-audio"
  | "com.audible.aa-audiobook"
  | "com.audible.aax-audiobook"
  | "com.avid.open-media-framework"
  | "com.barebones.bbedit.actionscript-source"
  | "com.barebones.bbedit.arduino-source"
  | "com.barebones.bbedit.asp-source"
  | "com.barebones.bbedit.cgi-script"
  | "com.barebones.bbedit.color-scheme"
  | "com.barebones.bbedit.ctags-data"
  | "com.barebones.bbedit.document-object"
  | "com.barebones.bbedit.dtdspec"
  | "com.barebones.bbedit.erb-source"
  | "com.barebones.bbedit.go-source"
  | "com.barebones.bbedit.ini-configuration"
  | "com.barebones.bbedit.jsp-source"
  | "com.barebones.bbedit.language-module"
  | "com.barebones.bbedit.lasso-source"
  | "com.barebones.bbedit.legacy-color-scheme"
  | "com.barebones.bbedit.legacy-project"
  | "com.barebones.bbedit.lua-source"
  | "com.barebones.bbedit.notebook"
  | "com.barebones.bbedit.package"
  | "com.barebones.bbedit.project"
  | "com.barebones.bbedit.r-source"
  | "com.barebones.bbedit.rust-source"
  | "com.barebones.bbedit.scss-source"
  | "com.barebones.bbedit.setext-source"
  | "com.barebones.bbedit.shell-worksheet"
  | "com.barebones.bbedit.sql-source"
  | "com.barebones.bbedit.tcl-source"
  | "com.barebones.bbedit.tex-source"
  | "com.barebones.bbedit.text-factory"
  | "com.barebones.bbedit.textdocument-object"
  | "com.barebones.bbedit.textile-source"
  | "com.barebones.bbedit.toml-source"
  | "com.barebones.bbedit.typescript-source"
  | "com.barebones.bbedit.vbscript-source"
  | "com.barebones.bbedit.vectorscript-source"
  | "com.barebones.bbedit.verilog-hdl-source"
  | "com.barebones.bbedit.vhdl-source"
  | "com.blackmagicdesign.cube"
  | "com.canon.cr2-raw-image"
  | "com.canon.cr3-raw-image"
  | "com.canon.crw-raw-image"
  | "com.canon.tif-raw-image"
  | "com.charliemonroe.downie.partial.download"
  | "com.coderunnerapp.config-file"
  | "com.coderunnerapp.crbindings"
  | "com.coderunnerapp.crdebugger"
  | "com.coderunnerapp.crlanguage"
  | "com.coderunnerapp.crtheme"
  | "com.coderunnerapp.include-file"
  | "com.compuserve.gif"
  | "com.corel.brush"
  | "com.culturedcode.things.database"
  | "com.dayoneapp.entry"
  | "com.dayoneapp.journal"
  | "com.dayoneapp.synckey"
  | "com.dec.modula-3"
  | "com.digidesign.sd2-audio"
  | "com.dxo.raw-image"
  | "com.ea.iff-ilbm"
  | "com.edovia.screens.archive"
  | "com.edovia.screens.license"
  | "com.epson.raw-image"
  | "com.evernote.enex"
  | "com.facebook.tar-zst-archive"
  | "com.facebook.zst-archive"
  | "com.figma.document"
  | "com.fournova.tower3.theme"
  | "com.fuji.raw-image"
  | "com.google.br-archive"
  | "com.google.tar-br-archive"
  | "com.google.webp"
  | "com.hasselblad.3fr-raw-image"
  | "com.hasselblad.fff-raw-image"
  | "com.highcaffeinecontent.radio.shared"
  | "com.hindsightlabs.paprika.files.recipe"
  | "com.hindsightlabs.paprika.files.recipes"
  | "com.hogbaysoftware.taskpaper"
  | "com.houdah.customshortcuts.shortcuts"
  | "com.ideasoncanvas.mindnode.theme"
  | "com.ilm.openexr-image"
  | "com.j2.efx-fax"
  | "com.j2.jfx-fax"
  | "com.jellyfish.jellycut"
  | "com.junecloud.deliveries"
  | "com.khanov.customutihandler.1blockpkg"
  | "com.kodak.flashpix-image"
  | "com.kodak.raw-image"
  | "com.konicaminolta.raw-image"
  | "com.lassosoft.lasso"
  | "com.leafamerica.raw-image"
  | "com.leica.pwl-raw-image"
  | "com.leica.raw-image"
  | "com.leica.rwl-raw-image"
  | "com.luki.blockmodel"
  | "com.lutron.bleap"
  | "com.macitbetter.betterzip.user-defined"
  | "com.macitbetter.cbr-archive"
  | "com.macitbetter.cbz-archive"
  | "com.macitbetter.segmented-archive"
  | "com.macitbetter.zip-archive"
  | "com.macromates.textmate.language"
  | "com.macromates.textmate.theme"
  | "com.microsoft.advanced-stream-redirector"
  | "com.microsoft.advanced-systems-format"
  | "com.microsoft.asp"
  | "com.microsoft.asp.net"
  | "com.microsoft.bmp"
  | "com.microsoft.c-sharp"
  | "com.microsoft.cab"
  | "com.microsoft.cab-archive"
  | "com.microsoft.chm-archive"
  | "com.microsoft.dds"
  | "com.microsoft.excel.sheet.binary.macroenabled"
  | "com.microsoft.excel.xla"
  | "com.microsoft.excel.xls"
  | "com.microsoft.excel.xlt"
  | "com.microsoft.excel.xlw"
  | "com.microsoft.ico"
  | "com.microsoft.ini"
  | "com.microsoft.internet-shortcut"
  | "com.microsoft.powerpoint.pot"
  | "com.microsoft.powerpoint.pps"
  | "com.microsoft.powerpoint.ppt"
  | "com.microsoft.powerpoint.presentation-object"
  | "com.microsoft.powerpoint.slide-object"
  | "com.microsoft.tnef"
  | "com.microsoft.typescript"
  | "com.microsoft.visual-basic"
  | "com.microsoft.waveform-audio"
  | "com.microsoft.windows-dynamic-link-library"
  | "com.microsoft.windows-executable"
  | "com.microsoft.windows-media-wax"
  | "com.microsoft.windows-media-wm"
  | "com.microsoft.windows-media-wma"
  | "com.microsoft.windows-media-wmp"
  | "com.microsoft.windows-media-wmv"
  | "com.microsoft.windows-media-wmx"
  | "com.microsoft.windows-media-wvx"
  | "com.microsoft.word.doc"
  | "com.microsoft.word.dot"
  | "com.microsoft.word.wordml"
  | "com.mindjet.mindmanager.map"
  | "com.mindjet.mindmanager.map.xml"
  | "com.mindjet.mindmanager.mmap"
  | "com.mindnode.mindnode.mindmap"
  | "com.mindnode.mindnode.sffmindmap"
  | "com.mips.mips-assembler"
  | "com.netscape.javascript-source"
  | "com.nikon.nrw-raw-image"
  | "com.nikon.raw-image"
  | "com.noodlesoft.hazel.license"
  | "com.noodlesoft.hazel.rules"
  | "com.olympus.or-raw-image"
  | "com.olympus.raw-image"
  | "com.olympus.sr-raw-image"
  | "com.panasonic.raw-image"
  | "com.panasonic.rw2-raw-image"
  | "com.panic.transmit.favoritemetadata"
  | "com.pcalc.customdice"
  | "com.pcalc.diceimages"
  | "com.pcalc.dicesets"
  | "com.pcalc.dicesettings"
  | "com.pcalc.dicetray"
  | "com.pentax.raw-image"
  | "com.phaseone.raw-image"
  | "com.pixar.universal-scene-description"
  | "com.pixar.universal-scene-description-mobile"
  | "com.pixar.usd.ascii"
  | "com.pixar.usd.crate"
  | "com.pixelmator.pxb"
  | "com.pixelmator.pxg"
  | "com.pixelmator.pxls"
  | "com.pixelmator.pxm"
  | "com.pixelmator.pxs"
  | "com.pixelmatorteam.adjustments"
  | "com.pixelmatorteam.brushes"
  | "com.pixelmatorteam.colorpalette"
  | "com.pixelmatorteam.effects"
  | "com.pixelmatorteam.gradients"
  | "com.pixelmatorteam.layerstyles"
  | "com.pixelmatorteam.legacy-touch-brushes"
  | "com.pixelmatorteam.pixelmator.document-package"
  | "com.pixelmatorteam.pixelmator.document.binary"
  | "com.pixelmatorteam.pixelmator.document.package"
  | "com.pixelmatorteam.shapes"
  | "com.pixelmatorteam.textstyles"
  | "com.pkware.zip-archive"
  | "com.rarlab.rar-archive"
  | "com.rarlab.rar-legacy-archive"
  | "com.real.realaudio"
  | "com.real.realmedia"
  | "com.real.realmedia-vbr"
  | "com.realmacsoftware.rapidweaver-3-document"
  | "com.realmacsoftware.rapidweaver-document"
  | "com.realmacsoftware.rapidweaver8-document"
  | "com.redhat.rpm-archive"
  | "com.redlex.opml"
  | "com.renfei.snippetslab.library"
  | "com.roxio.disk-image-toast"
  | "com.rsa.pkcs-12"
  | "com.samsung.raw-image"
  | "com.scenarist.closed-caption"
  | "com.sega.pvr-image"
  | "com.sgi.sgi-image"
  | "com.softwareambience.unclutter.license"
  | "com.sony.arw-raw-image"
  | "com.sony.raw-image"
  | "com.sony.sr2-raw-image"
  | "com.sony.wave64"
  | "com.soundblaster.soundfont"
  | "com.stuffit.archive.sidx"
  | "com.stuffit.archive.sit"
  | "com.stuffit.archive.sitx"
  | "com.sun.java-archive"
  | "com.sun.java-class"
  | "com.sun.java-properties"
  | "com.sun.java-server-pages"
  | "com.sun.java-source"
  | "com.sun.java-web-start"
  | "com.sun.web-application-archive"
  | "com.symantec.diskdoubler-archive"
  | "com.tascam.opentl"
  | "com.taskpaper.text"
  | "com.textpattern.textile"
  | "com.tinyapp.tableplus.connection.bundle"
  | "com.tinyapp.tableplus.plugin.bundle"
  | "com.toketaware.ithoughtsx"
  | "com.toketaware.uti.ithoughts.itmz"
  | "com.topographix.gpx"
  | "com.truevision.tga-image"
  | "com.xwavesoft.cloudoutliner.opml"
  | "com.zlineman.jelly"
  | "cx.c3.cb7-archive"
  | "cx.c3.cbr-archive"
  | "cx.c3.cbz-archive"
  | "cx.c3.maki-image"
  | "cx.c3.makichan-image"
  | "cx.c3.pcx"
  | "cx.c3.xpm-image"
  | "dev.cappuccino.objective-j"
  | "gov.nih.nifti-1"
  | "in.moinmo.wiki-source"
  | "io.iina.3gpp"
  | "io.iina.3gpp2"
  | "io.iina.aac"
  | "io.iina.ac3"
  | "io.iina.aiff"
  | "io.iina.ape"
  | "io.iina.asf"
  | "io.iina.avi"
  | "io.iina.cue"
  | "io.iina.divx"
  | "io.iina.dv"
  | "io.iina.flac"
  | "io.iina.flash"
  | "io.iina.mid"
  | "io.iina.mka"
  | "io.iina.mkv"
  | "io.iina.mpeg-audio"
  | "io.iina.mpeg-stream"
  | "io.iina.mpeg-video"
  | "io.iina.mpeg3-audio"
  | "io.iina.mpeg4-audio"
  | "io.iina.mpeg4-video"
  | "io.iina.ogg-audio"
  | "io.iina.ogg-video"
  | "io.iina.opus"
  | "io.iina.playlist"
  | "io.iina.quicktime"
  | "io.iina.realmedia"
  | "io.iina.vob"
  | "io.iina.wav"
  | "io.iina.webm"
  | "io.iina.wma"
  | "io.iina.wmv"
  | "io.iina.wtv"
  | "io.iina.wv"
  | "io.iina.xm"
  | "net.common-lisp.lisp"
  | "net.daringfireball.markdown"
  | "net.ia.markdown"
  | "net.smarty.smarty"
  | "net.sourceforge.grandperspectiv.scandump"
  | "net.sourceforge.netpbm.netpbm-image"
  | "org.3gpp.adaptive-multi-rate-audio"
  | "org.7-zip.7-zip-archive"
  | "org.7-zip.arj-archive"
  | "org.7-zip.lha-archive"
  | "org.7-zip.nsis-archive"
  | "org.aafassociation.advanced-authoring-format"
  | "org.beanshell.beanshell"
  | "org.bittorrent.torrent"
  | "org.blenderfoundation.blender.file"
  | "org.bzip.bzip2-archive"
  | "org.bzip.bzip2-tar-archive"
  | "org.chromium.extension"
  | "org.coffeescript.coffeescript"
  | "org.complang.ragel"
  | "org.contextfreeart.contextfree"
  | "org.debian.deb-archive"
  | "org.dlang.d"
  | "org.erlang.erlang"
  | "org.freemind.mm"
  | "org.fscript.fscript"
  | "org.gnu.gnu-tar-archive"
  | "org.gnu.gnu-zip-archive"
  | "org.gnu.gnu-zip-tar-archive"
  | "org.golang.go-source"
  | "org.idpf.epub-container"
  | "org.idpf.epub-folder"
  | "org.ietf.mhtml"
  | "org.iolanguage.io"
  | "org.iso.sql"
  | "org.khronos.astc"
  | "org.khronos.collada.digital-asset-exchange"
  | "org.khronos.glsl-source"
  | "org.khronos.glsl.fragment-shader"
  | "org.khronos.glsl.geometry-shader"
  | "org.khronos.glsl.tess-control-shader"
  | "org.khronos.glsl.tess-evaluation-shader"
  | "org.khronos.glsl.vertex-shader"
  | "org.khronos.ktx"
  | "org.kotlinlang.kotlin-source"
  | "org.lua.lua-source"
  | "org.mediawiki.wiki-source"
  | "org.nema.dicom"
  | "org.oasis-open.opendocument"
  | "org.oasis-open.opendocument.chart"
  | "org.oasis-open.opendocument.chart-template"
  | "org.oasis-open.opendocument.database"
  | "org.oasis-open.opendocument.formula"
  | "org.oasis-open.opendocument.formula-template"
  | "org.oasis-open.opendocument.graphics"
  | "org.oasis-open.opendocument.graphics-template"
  | "org.oasis-open.opendocument.image"
  | "org.oasis-open.opendocument.image-template"
  | "org.oasis-open.opendocument.presentation"
  | "org.oasis-open.opendocument.presentation-template"
  | "org.oasis-open.opendocument.spreadsheet"
  | "org.oasis-open.opendocument.spreadsheet-template"
  | "org.oasis-open.opendocument.text"
  | "org.oasis-open.opendocument.text-master"
  | "org.oasis-open.opendocument.text-template"
  | "org.oasis-open.opendocument.text-web"
  | "org.oasis-open.xliff"
  | "org.ocaml.ocaml"
  | "org.openoffice.formula"
  | "org.openoffice.graphics"
  | "org.openoffice.graphics-template"
  | "org.openoffice.presentation"
  | "org.openoffice.presentation-template"
  | "org.openoffice.spreadsheet"
  | "org.openoffice.spreadsheet-template"
  | "org.openoffice.text"
  | "org.openoffice.text-master"
  | "org.openoffice.text-template"
  | "org.openxmlformats.openxml"
  | "org.openxmlformats.presentationml.presentation"
  | "org.openxmlformats.presentationml.presentation.macroenabled"
  | "org.openxmlformats.presentationml.slideshow"
  | "org.openxmlformats.presentationml.slideshow.macroenabled"
  | "org.openxmlformats.presentationml.template"
  | "org.openxmlformats.presentationml.template.macroenabled"
  | "org.openxmlformats.spreadsheetml.sheet"
  | "org.openxmlformats.spreadsheetml.sheet.macroenabled"
  | "org.openxmlformats.spreadsheetml.template"
  | "org.openxmlformats.spreadsheetml.template.macroenabled"
  | "org.openxmlformats.wordprocessingml.document"
  | "org.openxmlformats.wordprocessingml.document.macro-enabled"
  | "org.openxmlformats.wordprocessingml.document.macroenabled"
  | "org.openxmlformats.wordprocessingml.template"
  | "org.openxmlformats.wordprocessingml.template.macro-enabled"
  | "org.openxmlformats.wordprocessingml.template.macroenabled"
  | "org.opml.opml"
  | "org.python.python-egg"
  | "org.python.restructuredtext"
  | "org.r-project.r"
  | "org.ruby-lang.eruby"
  | "org.rust-lang.rust-source"
  | "org.scheme-reports.scheme-source"
  | "org.slatelanguage.slate"
  | "org.sml-family.standard-ml"
  | "org.smpte.mxf"
  | "org.swig.swig"
  | "org.textbundle.compressed"
  | "org.textbundle.package"
  | "org.tug.bib"
  | "org.tug.cls"
  | "org.tug.sty"
  | "org.tug.tex"
  | "org.tug.tex.bibtex"
  | "org.tukaani.tar-xz-archive"
  | "org.tukaani.xz-archive"
  | "org.w3.webvtt"
  | "org.w3.xsl"
  | "org.webmproject.webm"
  | "org.webmproject.webp"
  | "org.xiph.flac"
  | "org.xiph.ogg-audio"
  | "org.xiph.ogv"
  | "org.xmind.openformat.xmind"
  | "public.3d-content"
  | "public.3gpp"
  | "public.3gpp2"
  | "public.aac-audio"
  | "public.ac3-audio"
  | "public.ada-source"
  | "public.aifc-audio"
  | "public.aiff-audio"
  | "public.alembic"
  | "public.app-category"
  | "public.app-category.action-games"
  | "public.app-category.adventure-games"
  | "public.app-category.arcade-games"
  | "public.app-category.board-games"
  | "public.app-category.bookmarks"
  | "public.app-category.books"
  | "public.app-category.business"
  | "public.app-category.card-games"
  | "public.app-category.casino-games"
  | "public.app-category.developer-tools"
  | "public.app-category.dice-games"
  | "public.app-category.education"
  | "public.app-category.educational-games"
  | "public.app-category.entertainment"
  | "public.app-category.family-games"
  | "public.app-category.finance"
  | "public.app-category.food-and-drink"
  | "public.app-category.games"
  | "public.app-category.graphics-design"
  | "public.app-category.healthcare-fitness"
  | "public.app-category.kids-games"
  | "public.app-category.lifestyle"
  | "public.app-category.magazines-and-newspapers"
  | "public.app-category.medical"
  | "public.app-category.music"
  | "public.app-category.music-games"
  | "public.app-category.navigation"
  | "public.app-category.news"
  | "public.app-category.photography"
  | "public.app-category.photography-and-video"
  | "public.app-category.productivity"
  | "public.app-category.puzzle-games"
  | "public.app-category.racing-games"
  | "public.app-category.reference"
  | "public.app-category.role-playing-games"
  | "public.app-category.shopping"
  | "public.app-category.simulation-games"
  | "public.app-category.social-networking"
  | "public.app-category.sports"
  | "public.app-category.sports-games"
  | "public.app-category.strategy-games"
  | "public.app-category.travel"
  | "public.app-category.trivia-games"
  | "public.app-category.utilities"
  | "public.app-category.video"
  | "public.app-category.weather"
  | "public.app-category.word-games"
  | "public.archive"
  | "public.assembly-source"
  | "public.au-audio"
  | "public.audio"
  | "public.audiovisual-content"
  | "public.audiovisual-content-collection"
  | "public.avchd-collection"
  | "public.avchd-content"
  | "public.avchd-mpeg-2-transport-stream"
  | "public.avci"
  | "public.avcs"
  | "public.avi"
  | "public.bash-script"
  | "public.block-special"
  | "public.bookmark"
  | "public.bzip2-archive"
  | "public.c-header"
  | "public.c-plus-plus-header"
  | "public.c-plus-plus-inline-header"
  | "public.c-plus-plus-source"
  | "public.c-plus-plus-source.preprocessed"
  | "public.c-source"
  | "public.c-source.preprocessed"
  | "public.calendar-event"
  | "public.camera-raw-image"
  | "public.case-insensitive-text"
  | "public.cd-based-media"
  | "public.cd-media"
  | "public.cd-r-media"
  | "public.cd-rw-media"
  | "public.cdda-audio"
  | "public.character-special"
  | "public.comma-separated-values-text"
  | "public.composite-content"
  | "public.computer"
  | "public.contact"
  | "public.content"
  | "public.cpio-archive"
  | "public.csh-script"
  | "public.css"
  | "public.data"
  | "public.database"
  | "public.delimited-values-text"
  | "public.device"
  | "public.directory"
  | "public.disk-image"
  | "public.display"
  | "public.downloadable-sound"
  | "public.dv-movie"
  | "public.dvd-based-media"
  | "public.dvd-media"
  | "public.dvd-plus-r-media"
  | "public.dvd-plus-rw-media"
  | "public.dvd-r-media"
  | "public.dvd-ram-media"
  | "public.dvd-rw-media"
  | "public.dylan-source"
  | "public.elf-binary"
  | "public.email-message"
  | "public.enhanced-ac3-audio"
  | "public.executable"
  | "public.fax"
  | "public.file-sharepoint"
  | "public.file-url"
  | "public.filename-extension"
  | "public.flc-animation"
  | "public.folder"
  | "public.font"
  | "public.fortran-77-source"
  | "public.fortran-90-source"
  | "public.fortran-95-source"
  | "public.fortran-source"
  | "public.generic-pc"
  | "public.geometry-definition-format"
  | "public.haptics-content"
  | "public.haskell-source"
  | "public.hd-dvd-based-media"
  | "public.hd-dvd-media"
  | "public.hd-dvd-r-media"
  | "public.hd-dvd-ram-media"
  | "public.hd-dvd-rw-media"
  | "public.heic"
  | "public.heics"
  | "public.heif"
  | "public.heif-standard"
  | "public.heifs"
  | "public.html"
  | "public.image"
  | "public.iso-diskimage"
  | "public.iso-image"
  | "public.item"
  | "public.jpeg"
  | "public.jpeg-2000"
  | "public.json"
  | "public.ksh-script"
  | "public.lex-source"
  | "public.log"
  | "public.m3u-playlist"
  | "public.make-source"
  | "public.message"
  | "public.midi-audio"
  | "public.mig-source"
  | "public.mime-type"
  | "public.module-map"
  | "public.movie"
  | "public.mp2"
  | "public.mp3"
  | "public.mp4a-latm"
  | "public.mp4a-loas"
  | "public.mpeg"
  | "public.mpeg-2-transport-stream"
  | "public.mpeg-2-video"
  | "public.mpeg-4"
  | "public.mpeg-4-audio"
  | "public.mpo-image"
  | "public.named-pipe"
  | "public.nasm-assembly-source"
  | "public.object-code"
  | "public.objective-c-plus-plus-source"
  | "public.objective-c-plus-plus-source.preprocessed"
  | "public.objective-c-source"
  | "public.objective-c-source.preprocessed"
  | "public.ofd"
  | "public.opencl-source"
  | "public.opentype-collection-font"
  | "public.opentype-font"
  | "public.optical-storage-media"
  | "public.pascal-source"
  | "public.patch-file"
  | "public.pbm"
  | "public.perl-script"
  | "public.php-script"
  | "public.plain-text"
  | "public.playlist"
  | "public.pls-playlist"
  | "public.png"
  | "public.polygon-file-format"
  | "public.precompiled-c-header"
  | "public.precompiled-c-plus-plus-header"
  | "public.presentation"
  | "public.protobuf-source"
  | "public.pvr"
  | "public.python-script"
  | "public.radiance"
  | "public.rss"
  | "public.rtf"
  | "public.ruby-script"
  | "public.script"
  | "public.sdp"
  | "public.shell-script"
  | "public.socket"
  | "public.source-code"
  | "public.source-code.preprocessed"
  | "public.speaker"
  | "public.spreadsheet"
  | "public.standard-tesselated-geometry-format"
  | "public.storage"
  | "public.stored-url"
  | "public.svg-image"
  | "public.swift-source"
  | "public.symlink"
  | "public.tab-separated-values-text"
  | "public.tar-archive"
  | "public.tar-bzip2-archive"
  | "public.tcsh-script"
  | "public.text"
  | "public.tiff"
  | "public.to-do-item"
  | "public.truetype-collection-font"
  | "public.truetype-font"
  | "public.truetype-ttf-font"
  | "public.ulaw-audio"
  | "public.unix-executable"
  | "public.url"
  | "public.url-name"
  | "public.utf16-external-plain-text"
  | "public.utf16-plain-text"
  | "public.utf8-plain-text"
  | "public.utf8-tab-separated-values-text"
  | "public.uuencoded-archive"
  | "public.vcard"
  | "public.video"
  | "public.volume"
  | "public.webp"
  | "public.x509-certificate"
  | "public.x509-printable-encoded-archive"
  | "public.xbitmap-image"
  | "public.xfd"
  | "public.xhtml"
  | "public.xml"
  | "public.yacc-source"
  | "public.yaml"
  | "public.z-archive"
  | "public.zip-archive"
  | "public.zsh-script"
  | "tk.tcl.tcl"
  | "unofficial.opml"
  | "ws.agile.agilekeychain";

export type UniformTypeIdentifier =
  | UniformTypeIdentifierBase 
  | (string & {});